import { createSelector } from '@reduxjs/toolkit';
import { getOrganizationId } from '../organization/getOrganizationId';
import { tasksNotDeletedWithFunctionName } from './tasks-not-deleted-with-function-name';
import { functionsNotDeleted } from './functions-not-deleted';
import type { TaskViewModel } from '@trinnvis/dabih-api-client';

import { _sortByName } from '../utilities/_sortByName';

export const tasksForAssets = createSelector(
  getOrganizationId,
  tasksNotDeletedWithFunctionName,
  functionsNotDeleted,
  (organizationId, tasks, functions) => {
    const isMainAssetFunction = (functionUuid: string): boolean => {
      const f = functions.filter((item) => item.uuid === functionUuid)[0];
      if (f) {
        return f.templateId === 190;
      }
      return false;
    };

    const isOtherAssetFunction = (functionUuid: string): boolean => {
      const f = functions.filter((item) => item.uuid === functionUuid)[0];
      if (f) {
        return f.pages !== undefined && f.pages.includes(355);
      }
      return false;
    };

    const href = (task: TaskViewModel): string => {
      const page = (functionUuid: string): number => {
        const parentFunction = functions.filter((item) => item.uuid === functionUuid)[0];
        if (parentFunction && parentFunction.pages !== undefined && parentFunction.pages.length > 0) {
          return parentFunction.pages[0];
        }
        throw Error('Illegal state (E901)');
      };

      if (task.pages !== undefined && task.pages.includes(355)) {
        return '/account/' + organizationId + '/355/tasks/' + task.uuid;
      } else if (isMainAssetFunction(task.functionUuid) || isOtherAssetFunction(task.functionUuid)) {
        return '/account/' + organizationId + '/355/functions/' + task.functionUuid + '/tasks/' + task.uuid;
      } else {
        return (
          '/account/' +
          organizationId +
          '/' +
          page(task.functionUuid) +
          '/functions/' +
          task.functionUuid +
          '/tasks/' +
          task.uuid
        );
      }
    };

    return tasks
      .map((item) => {
        let sort = 9;
        if (item.assets.length) {
          sort = 1;
        } else if (isMainAssetFunction(item.functionUuid)) {
          sort = 2;
        } else if (isOtherAssetFunction(item.functionUuid)) {
          sort = 3;
        } else if (item.pages !== undefined && item.pages.includes(355)) {
          sort = 4;
        }
        return { ...item, href: href(item), sort };
      })
      .sort(_sortByName)
      .sort((a, b) => a.sort - b.sort);
  },
);
